/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Spec_Release_VInputs */

const en_home_spec_release_v = /** @type {(inputs: Home_Spec_Release_VInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`v0.8.0, in active development`)
};

/**
* | output |
* | --- |
* | "v0.8.0, in active development" |
*
* @param {Home_Spec_Release_VInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_spec_release_v = /** @type {((inputs?: Home_Spec_Release_VInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Spec_Release_VInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_spec_release_v(inputs)
});
export { home_spec_release_v as "home.spec.release_v" }